export default "__VITE_ASSET__CMmVMjim__"